/* MerryPawsie — interactividad (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var f = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: f }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  function toast(msg) {
    var t = document.querySelector('.mp-toast');
    if (!t) { t = document.createElement('div'); t.className = 'mp-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* Suma días hábiles (sin sábados ni domingos) */
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }

  /* ---------- Reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.mp-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('mp-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('mp-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Nieve ---------- */
  function initNieve() {
    if (reduce) return;
    document.querySelectorAll('[data-mp-nieve]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = 1;
      var n = parseInt(box.dataset.mpNieve, 10) || 0;
      if (window.innerWidth < 600) n = Math.round(n * 0.5);
      var glyphs = ['❄', '❅', '•', '❆'];
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span');
        s.className = 'mp-copo';
        s.textContent = glyphs[i % glyphs.length];
        s.style.left = (Math.random() * 100) + '%';
        s.style.fontSize = (8 + Math.random() * 16) + 'px';
        s.style.opacity = (0.45 + Math.random() * 0.5).toFixed(2);
        s.style.animationDuration = (9 + Math.random() * 12) + 's';
        s.style.animationDelay = (-Math.random() * 20) + 's';
        s.style.setProperty('--x', (Math.random() * 80 - 40) + 'px');
        box.appendChild(s);
      }
    });
  }

  /* ---------- Cuenta atrás ---------- */
  function initCuenta() {
    document.querySelectorAll('[data-mp-cuenta]').forEach(function (el) {
      var fin = new Date(el.dataset.mpCuenta);
      if (isNaN(fin)) return;
      var root = el.closest('.mp-cuenta') || el;
      var u = { d: el.querySelector('[data-u=d]'), h: el.querySelector('[data-u=h]'), m: el.querySelector('[data-u=m]'), s: el.querySelector('[data-u=s]') };
      function pad(x) { return x < 10 ? '0' + x : '' + x; }
      function tick() {
        var diff = fin - new Date();
        if (diff <= 0) { root.classList.add('is-fin'); clearInterval(t); return; }
        var s = Math.floor(diff / 1000);
        if (u.d) u.d.textContent = Math.floor(s / 86400);
        if (u.h) u.h.textContent = pad(Math.floor(s % 86400 / 3600));
        if (u.m) u.m.textContent = pad(Math.floor(s % 3600 / 60));
        if (u.s) u.s.textContent = pad(s % 60);
      }
      var t = setInterval(tick, 1000); tick();
    });
    /* Texto de urgencia "X days left" */
    document.querySelectorAll('[data-mp-dias]').forEach(function (el) {
      var fin = new Date(el.dataset.mpDias);
      var box = el.closest('[data-mp-urg]');
      var dias = Math.floor((fin - new Date()) / 86400000);
      if (isNaN(fin) || dias < 0) { if (box) box.hidden = true; return; }
      if (dias > 14 && box) {
        var txt = box.querySelector('span:not([aria-hidden])');
        if (txt) txt.innerHTML = 'Order by <b>' + fin.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) + '</b> to get it before Christmas 🎅';
        return;
      }
      el.textContent = dias === 0 ? 'today' : (dias === 1 ? '1 day' : dias + ' days');
    });
  }

  /* ---------- Fechas de envío ---------- */
  function initEntrega() {
    var hoy = new Date();
    document.querySelectorAll('[data-mp-fecha]').forEach(function (el) {
      var p = el.dataset.mpFecha.split('-');
      var a = parseInt(p[0], 10) || 0, b = parseInt(p[1] || p[0], 10) || 0;
      if (a === 0 && b === 0) { el.textContent = fmt(hoy); return; }
      var d1 = addBusinessDays(hoy, a), d2 = addBusinessDays(hoy, b);
      el.textContent = a === b ? fmt(d1) : fmt(d1) + ' – ' + fmt(d2);
    });
  }

  /* ---------- Carrito: añadir y abrir el cajón de Dawn ---------- */
  function addToCart(items, btn) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    if (btn) { btn.disabled = true; btn.dataset.txt = btn.dataset.txt || btn.innerHTML; btn.innerHTML = 'Adding…'; }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { toast(res.description || res.message || 'Could not add to cart'); return; }
      if (drawer && res.sections && typeof drawer.renderContents === 'function') {
        try { drawer.classList.remove('is-empty'); drawer.renderContents(res); return; } catch (e) { }
      }
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }).catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = btn.dataset.txt; } });
  }

  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-mp-quick]');
      if (!f) return;
      e.preventDefault();
      var id = f.querySelector('[name=id]').value;
      addToCart([{ id: Number(id), quantity: 1 }], f.querySelector('button[type=submit]'));
    });
  }

  /* ---------- Página de producto ---------- */
  function initPDP() {
    document.querySelectorAll('[data-mp-pdp]').forEach(function (root) {
      var dataEl = root.querySelector('[data-mp-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = root.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('[name=id]');
      var qtyInput = form && form.querySelector('[name=quantity]');
      var btn = root.querySelector('[data-mp-add]');
      var btnTxt = btn ? btn.innerHTML : '';
      var precioEl = root.querySelector('[data-mp-precio]');
      var compEl = root.querySelector('[data-mp-comp]');
      var main = root.querySelector('[data-mp-main]');
      var tiers = root.querySelectorAll('.mp-tier');
      var sticky = document.querySelector('[data-mp-sticky]');
      var current = variants.find(function (v) { return String(v.id) === (idInput && idInput.value); }) || variants[0];

      /* galería */
      root.querySelectorAll('.mp-pdp__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          root.querySelectorAll('.mp-pdp__thumb').forEach(function (x) { x.classList.remove('is-on'); });
          t.classList.add('is-on');
          main.src = t.dataset.src; main.srcset = ''; main.alt = t.dataset.alt || '';
        });
      });

      function precioTiers() {
        if (!current) return;
        tiers.forEach(function (tier) {
          var q = parseInt(tier.dataset.qty, 10), off = parseFloat(tier.dataset.off) || 0;
          var full = current.price * q, final = Math.round(full * (1 - off / 100));
          var p = tier.querySelector('[data-p]'), s = tier.querySelector('[data-s]');
          if (p) p.textContent = money(final);
          if (s) s.textContent = off > 0 ? money(full) : '';
        });
      }

      function render() {
        if (!current) return;
        if (idInput) idInput.value = current.id;
        if (precioEl) precioEl.textContent = money(current.price);
        if (compEl) compEl.textContent = current.compare_at_price > current.price ? money(current.compare_at_price) : '';
        if (btn) { btn.disabled = !current.available; btn.innerHTML = current.available ? btnTxt : (btn.dataset.agotado || 'Sold out'); }
        /* Cambia la foto principal a la del color/variante elegida */
        var fm = current.featured_media;
        var th = fm && root.querySelector('.mp-pdp__thumb[data-id="' + fm.id + '"]');
        if (th) { th.click(); }
        else if (current.featured_image && main) { main.src = current.featured_image.src; main.srcset = ''; }
        precioTiers();
        if (sticky) { var sp = sticky.querySelector('[data-mp-sticky-precio]'); if (sp) sp.textContent = money(current.price); }
      }

      /* variantes */
      root.querySelectorAll('.mp-opt input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = Array.prototype.map.call(root.querySelectorAll('.mp-opt'), function (fs) {
            var c = fs.querySelector('input:checked'); return c ? c.value : null;
          });
          var v = variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) {
            /* Combinación inexistente: elegimos la variante disponible que respete la opción recién tocada */
            var idx = Array.prototype.indexOf.call(root.querySelectorAll('.mp-opt'), inp.closest('.mp-opt'));
            v = variants.find(function (x) { return x.available && x.options[idx] === inp.value; }) ||
                variants.find(function (x) { return x.options[idx] === inp.value; });
            if (v) {
              root.querySelectorAll('.mp-opt').forEach(function (fs, i) {
                fs.querySelectorAll('input').forEach(function (r) { r.checked = (r.value === v.options[i]); });
              });
            }
          }
          if (v) { current = v; } else if (btn) { btn.disabled = true; btn.innerHTML = btn.dataset.nodisp || 'Unavailable'; return; }
          render();
        });
      });

      /* packs */
      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () {
          tiers.forEach(function (x) { x.classList.remove('is-on'); x.querySelector('input').checked = false; });
          tier.classList.add('is-on'); tier.querySelector('input').checked = true;
          if (qtyInput) qtyInput.value = tier.dataset.qty;
        });
      });

      /* añadir */
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart([{ id: Number(idInput.value), quantity: Number(qtyInput ? qtyInput.value : 1) }], btn);
      });

      /* barra fija en móvil */
      if (sticky && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var r = en[0];
          sticky.classList.toggle('is-on', !r.isIntersecting && (r.boundingClientRect.top < 0 || window.innerWidth < 750));
        }).observe(btn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else btn.click(); });
      }
      render();
    });
  }

  /* ---------- Nieve global ---------- */
  function initNieveGlobal() {
    var box = document.querySelector('[data-mp-global]');
    if (!box || reduce || box.dataset.ready) return; box.dataset.ready = 1;
    var movil = window.innerWidth < 750;
    var n = parseInt(movil ? box.dataset.movil : box.dataset.pc, 10) || 0;
    var oro = box.dataset.oro === 'true';
    var r = function (a, b) { return a + Math.random() * (b - a); };
    var frag = document.createDocumentFragment();
    for (var i = 0; i < n; i++) {
      var tipo = (oro && i % 9 === 0) ? 'oro' : (i % 3 === 0 ? 'cristal' : 'copo');
      var f = document.createElement('span');
      f.className = 'mp-flake mp-flake--' + tipo;
      var size = tipo === 'copo' ? r(5, 9) : r(10, 15);
      f.style.cssText = '--l:' + r(0, 100).toFixed(1) + '%;--s:' + size.toFixed(1) + 'px;--o:' + r(.35, .6).toFixed(2) +
        ';--t:' + r(18, 30).toFixed(1) + 's;--dl:-' + r(0, 22).toFixed(1) + 's;--w:' + r(2.5, 5).toFixed(1) + 's;--x:' + r(10, 34).toFixed(0) + 'px;--r:' + r(-200, 200).toFixed(0) + 'deg';
      var inner = document.createElement('i');
      if (tipo === 'cristal') inner.textContent = ['❄', '❅', '❆'][i % 3];
      if (tipo === 'oro') inner.textContent = '✦';
      f.appendChild(inner); frag.appendChild(f);
    }
    box.appendChild(frag);
  }

  /* ---------- Aviso de cookies (Customer Privacy API de Shopify) ---------- */
  function initCookies() {
    var box = document.getElementById('mp-cookies');
    if (!box || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) return;
      var cp = window.Shopify.customerPrivacy;
      if (!cp) return;
      var c = cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
      var decidido = c && c.marketing && c.marketing !== '';
      if (decidido) return;
      var delay = (parseInt(box.dataset.delay, 10) || 0) * 1000;
      setTimeout(function () { box.hidden = false; requestAnimationFrame(function () { box.classList.add('is-on'); }); }, delay);
      box.querySelectorAll('[data-mp-consent]').forEach(function (b) {
        b.addEventListener('click', function () {
          var si = b.dataset.mpConsent === 'yes';
          cp.setTrackingConsent({ analytics: si, marketing: si, preferences: si, sale_of_data: si }, function () {});
          box.classList.remove('is-on');
          setTimeout(function () { box.hidden = true; }, 400);
        });
      });
    });
  }

  /* ---------- Popup de bienvenida ---------- */
  function initPopup() {
    var pop = document.getElementById('mp-pop');
    if (!pop) return;
    var KEY = 'mp_pop_hasta';
    function abrir() { pop.hidden = false; requestAnimationFrame(function () { pop.classList.add('is-on'); }); document.documentElement.classList.add('mp-pop-abierto'); }
    function cerrar() {
      pop.classList.remove('is-on'); document.documentElement.classList.remove('mp-pop-abierto');
      setTimeout(function () { pop.hidden = true; }, 350);
      try { localStorage.setItem(KEY, String(Date.now() + (parseInt(pop.dataset.dias, 10) || 7) * 864e5)); } catch (e) {}
    }
    pop.querySelectorAll('[data-mp-pop-close]').forEach(function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) cerrar(); });
    if (pop.dataset.ok || pop.dataset.err) {
      if (pop.dataset.ok) { try { localStorage.setItem(KEY, String(Date.now() + 3650 * 864e5)); } catch (e) {} }
      abrir(); return;
    }
    var hasta = 0; try { hasta = parseInt(localStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (hasta > Date.now()) return;
    var hecho = false;
    function intentar() {
      if (hecho) return;
      var ck = document.getElementById('mp-cookies');
      if (ck && !ck.hidden) { setTimeout(intentar, 2000); return; }
      hecho = true; abrir();
    }
    setTimeout(intentar, (parseInt(pop.dataset.delay, 10) || 12) * 1000);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10 && window.innerWidth > 990) intentar(); });
  }

  function init() { initPopup(); initCookies(); initNieveGlobal(); initReveal(); initNieve(); initCuenta(); initEntrega(); initQuickAdd(); initPDP(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initReveal(); initNieve(); initCuenta(); initEntrega(); initPDP(); });
})();
